module.exports = __webpack_public_path__ + "static/family-wide-f065da31e7e1e83a5b570eed5617248b.jpeg";